import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { dayChange } from '../../actions/index'

class WeekButtons extends React.Component {

    handleDayChange(side){
        if (side  === 'left') {
            if (parseInt(this.props.day) - 7 >= 0) {
                this.props.dayChange((this.props.day - 7))            
            } else {
                this.props.dayChange(0)            
            }
        } else if (side === 'right') {
            if (parseInt(this.props.day) + 7 < this.props.projectData.days.length) {
                this.props.dayChange((this.props.day + 7))
            } else {
                this.props.dayChange((this.props.projectData.days.length - 1))
            }
        }
    }

    render() {
        const right = '>'
        const left = '<'
        return(
            <div>
                <div className="week-button-layout card-subcolor">
                    <button className="week-button" onClick={() => this.handleDayChange("left")}>{left}</button>
                    <spacer type="horizontal" width="100" height="100"> </spacer>
                    <button className="week-button" onClick={() => this.handleDayChange("right")}>{right}</button>
                </div>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        day         : state.day,
        projectData : state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        dayChange    : dayChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(WeekButtons);